<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="serviceAchievementForm" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="技术成果展品名称" prop="ServiceAchievement.achievementName">
            <el-input class="input-item" v-model="formData.ServiceAchievement.achievementName"
                      :clearable="true" placeholder="技术成果展品名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="展品展示简介" prop="ServiceAchievement.achievementDesc">
            <el-input class="input-item" v-model="formData.ServiceAchievement.achievementDesc"
                      type="textarea"
                      :autosize="{minRows: 3, maxRows: 6}"
                      :clearable="true" placeholder="展品展示简介"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="参展单位" prop="ServiceAchievement.exhibitionUnit">
            <el-input class="input-item" v-model="formData.ServiceAchievement.exhibitionUnit"
                      :clearable="true" placeholder="参展单位"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="科技特派员" prop="ServiceAchievement.specialistName">
            <el-input class="input-item" v-model="formData.ServiceAchievement.specialistName"
                      :clearable="true" placeholder="科技特派员"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="图片" prop="ServiceAchievement.imageUrl">
            <el-upload
              class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
              :action="getUploadActionUrl('/admin/app/serviceAchievement/upload')"
              :data="{fieldName: 'imageUrl', asImage: true}"
              :on-success="onImageUrlUploadSuccess"
              :on-remove="onImageUrlRemoveFile"
              :on-error="onUploadError"
              :show-file-list="true"
              :on-preview="handlePreview"
              :limit="serviceAchievementForm.imageUrl.impl.maxCount"
              :on-exceed="onUploadLimit"
              :file-list="serviceAchievementForm.imageUrl.impl.fileList"
              list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="ServiceAchievement.remark">
            <el-input class="input-item" v-model="formData.ServiceAchievement.remark"
                      type="textarea"
                      :autosize="{minRows: 1, maxRows: 1}"
                      :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize"
                      :disabled="(mode === 'update' && !checkPermCodeExist('serviceAchievement:all'))"
                      @click="onSaveClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>

</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { ServiceAchievementController } from '@/api';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  name: 'serviceAchievementForm',
  props: {
    id: {
      default: undefined
    },
    mode: {
      type: String,
      default: 'update', // 'add' or 'update'
      validator: (value) => ['add', 'update'].includes(value)
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        ServiceAchievement: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          achievementName: undefined,
          achievementDesc: undefined,
          exhibitionUnit: undefined,
          specialistName: undefined,
          imageUrl: undefined,
          remark: undefined,
          comment: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'ServiceAchievement.achievementName': [
          {required: true, message: '请输入技术成果展品名称', trigger: 'blur'}
        ],
        'ServiceAchievement.achievementDesc': [
          {required: true, message: '请输入展品展示简介', trigger: 'blur'}
        ],
        'ServiceAchievement.exhibitionUnit': [
          {required: true, message: '请输入参展单位', trigger: 'blur'}
        ],
        'ServiceAchievement.specialistName': [
          {required: true, message: '请输入科技特派员', trigger: 'blur'}
        ]
      },
      serviceAchievementForm: {
        formFilter: {},
        formFilterCopy: {},
        menuBlock: {
          isInit: false
        },
        imageUrl: {
          impl: new UploadWidget(1)
        },
        isInit: false
      },
      imgViewerVisible: false,
      imgList: []
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    onImageUrlUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.serviceAchievementForm.imageUrl.impl.onFileChange(file, fileList);
        this.formData.ServiceAchievement.imageUrl = this.fileListToJson(this.serviceAchievementForm.imageUrl.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    onImageUrlRemoveFile (file, fileList) {
      this.serviceAchievementForm.imageUrl.impl.onFileChange(file, fileList);
      this.formData.ServiceAchievement.imageUrl = this.fileListToJson(this.serviceAchievementForm.imageUrl.impl.fileList);
    },
    /**
     * 上传失败
     */
    onUploadError (e, file, fileList) {
      this.$message.error('上传失败');
    },
    /**
     * 上传超出限制
     */
    onUploadLimit (file, fileList) {
      this.$message.error(`最多只能上传${this.serviceAchievementForm.imageUrl.impl.maxCount}个文件`);
    },

    /**
     * 刷新表单数据
     */
    refreshServiceAchievementForm (reloadData = false) {
      if (this.mode === 'add') {
        this.resetFormData();
        this.serviceAchievementForm.isInit = true;
      } else {
        this.loadServiceAchievementData().then(res => {
          this.serviceAchievementForm.isInit = true;
        }).catch(e => {});
      }
    },
    /**
     * 保存
     */
    onSaveClick () {
      this.$refs.serviceAchievementForm.validate((valid) => {
        if (!valid) return;
        let params = {
          serviceAchievementDto: {
            ...(this.mode === 'add' ? {
              achievementName: this.formData.ServiceAchievement.achievementName,
              achievementDesc: this.formData.ServiceAchievement.achievementDesc,
              exhibitionUnit: this.formData.ServiceAchievement.exhibitionUnit,
              specialistName: this.formData.ServiceAchievement.specialistName,
              imageUrl: this.formData.ServiceAchievement.imageUrl,
              remark: this.formData.ServiceAchievement.remark
            } : this.formData.ServiceAchievement)
          }
        };

        const savePromise = this.mode === 'add'
          ? ServiceAchievementController.add(this, params)
          : ServiceAchievementController.update(this, params);

        savePromise.then(res => {
          this.$message.success('保存成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    onResume () {
      this.refreshServiceAchievementForm(true);
    },
    /**
     * 获取服务成果信息详细信息
     */
    loadServiceAchievementData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.ServiceAchievement.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          ServiceAchievementController.view(this, params).then(res => {
            this.formData.ServiceAchievement = {...res.data, isDatasourceInit: true};

            let imageUrlDownloadParams = {
              id: this.formData.ServiceAchievement.id,
              fieldName: 'imageUrl',
              asImage: true
            };
            this.serviceAchievementForm.imageUrl.impl.fileList = this.parseUploadData(this.formData.ServiceAchievement.imageUrl, imageUrlDownloadParams);

            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.ServiceAchievement.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },

    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        ServiceAchievement: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          achievementName: undefined,
          achievementDesc: undefined,
          exhibitionUnit: undefined,
          specialistName: undefined,
          imageUrl: undefined,
          remark: undefined,
          comment: {
          },
          isDatasourceInit: false
        }
      };
      this.serviceAchievementForm.imageUrl.impl.fileList = [];
    },
    formInit () {
      this.refreshServiceAchievementForm();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
